var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showloadding)?_c('div',[_c('van-loading',{staticClass:"pfa-ladding",attrs:{"type":"spinner","size":"24px"}},[_vm._v("加载中...")])],1):_c('div',[_vm._t("default",[_c('div',{staticClass:"nodata"},[_vm._v(_vm._s(_vm.text))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }